module.exports = __webpack_public_path__ + "img/alexandria_soul_splice.df2218bd.png";